import { device } from '@src/common/breakpoints';
import { When } from '@src/common/calendar';
import { colors, LayoutColors } from '@src/core/theme';
import { BodyExtraSmallMedium, BodyRegularSemiBold, BodySmallMedium } from '@src/fonts/typography/Typography';
import styled, { css } from 'styled-components';

interface DateAreaProps {
  when: When;
  pending: boolean;
  isAvailable: boolean;
  date: Date;
  selectedMonth: number;
  isSoldOut: boolean;
}

interface DateTextAreaProps {
  isAvailable: boolean;
  isFuture: boolean;
  isPrice?: boolean;
}

interface WeekDayNameAreaProps {
  pending: boolean;
}

export const DateArea = styled.button<DateAreaProps>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 42px;
  max-width: 100%;
  height: 43px;
  padding: 2px;
  border: '2px solid transparent';
  border-radius: 4px;
  cursor: default;
  gap: 2px;
  color: ${LayoutColors.blackMain};

  transition: background-color border 0.3s ease-in;

  ${device.smallTablet} {
    height: 45px;
    width: 69px;
  }

  ${({ pending, when, isAvailable, isSoldOut }) => {
    if (pending) return PendingCSS;
    else if ((!isAvailable && !isSoldOut) || when === When.PAST) return IsUnavailable;
    else if (isAvailable) {
      return IsAvailable;
    } else if (isSoldOut) {
      return IsSoldOut;
    } else return '';
  }}

  ${({ when }) => (when == When.TODAY ? IsToday : '')}
`;

const IsAvailable = css`
  background-color: #46b96c;
  cursor: pointer;
  color: #ffffff;

  &:hover {
    background-color: #358c52;
  }

  &:active {
    background-color: #46b96c;
    border: 2px solid #2a7643;
  }
`;

const IsToday = css`
  border: 2px solid ${LayoutColors.justBlue};
`;

const IsSoldOut = css`
  background-color: ${colors.black[200]};
  cursor: not-allowed;
  color: ${LayoutColors.blackMain};
`;

const IsUnavailable = css`
  background: transparent;
  background-color: transparent;

  color: ${colors.black[400]};
`;

export const DateAreaText = styled.p<DateTextAreaProps>`
  ${({ isPrice }) => (isPrice ? BodyExtraSmallMedium : BodySmallMedium)}
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  color: inherit;

  span {
    display: none;
  }

  ${device.mobile} {
    span {
      display: inline;
    }
  }
`;

const PendingCSS = css`
  animation: 4s ease ripple infinite;
  & {
    border: none;
    color: transparent;
  }
  ${DateAreaText} {
    visibility: hidden;
  }
  @keyframes ripple {
    0% {
      background-color: #cdcdcd;
    }

    50% {
      background-color: transparent;
    }
    100% {
      background-color: #cdcdcd;
    }
  }
`;

export const WeekDayNameArea = styled.p<WeekDayNameAreaProps>`
  ${BodySmallMedium}
  color: ${LayoutColors.blackMain}
  text-align: center;

  ${device.mobile} {
    ${BodyRegularSemiBold}
  }
  ${(props) => (props.pending ? PendingCSS : '')}
`;

export const Container = styled.div`
  display: grid;
  justify-items: center;
  gap: 4px;
  grid-template-columns: repeat(7, 1fr);

  @media (min-width: 375px) {
    gap: 8px;
  }

  ${device.smallTablet} {
    gap: 16px;
  }
`;
